import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

export interface VerifyOtpCodeVariables {
  input: {
    verificationToken: string;
    otpCode: string;
  };
}

export interface VerifyOtpCodeResponse {
  verifyOtpCode: {
    status: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class OtpVerificationService extends Mutation<VerifyOtpCodeResponse, VerifyOtpCodeVariables> {
  document = gql`
    mutation VerifyOtpCode($input: VerifyOtpCodeInput!) {
      verifyOtpCode(input: $input) {
        status
      }
    }
  `;
}
